/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_3_Item_MonitoringInputs */

const en_privacy_section_3_item_monitoring = /** @type {(inputs: Privacy_Section_3_Item_MonitoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitoring errors`)
};

const lv_privacy_section_3_item_monitoring = /** @type {(inputs: Privacy_Section_3_Item_MonitoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kļūdu uzraudzība`)
};

/**
* | output |
* | --- |
* | "Monitoring errors" |
*
* @param {Privacy_Section_3_Item_MonitoringInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_3_item_monitoring = /** @type {((inputs?: Privacy_Section_3_Item_MonitoringInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_3_Item_MonitoringInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_3_item_monitoring(inputs)
	return en_privacy_section_3_item_monitoring(inputs)
});